import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getLangFromPathname, getLocalizedPath } from "../../components/LanguageRouteSync";

interface MenuProps {
  onItemClick?: () => void;
}

const Menu: React.FC<MenuProps> = ({ onItemClick }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentLang = getLangFromPathname(location.pathname);

  return (
    <div className="space-y-2 py-4">
      <a
        href={getLocalizedPath("/", currentLang) + "#about"}
        onClick={onItemClick}
        className="w-full block text-[#020220] text-lg font-semibold leading-10 hover:text-[#037897] transition-colors"
      >
        {t("nav.about")}
      </a>
      <Link
        to={getLocalizedPath("/programs", currentLang)}
        onClick={onItemClick}
        className="w-full block text-[#020220] text-lg font-semibold leading-10 hover:text-[#037897] transition-colors"
      >
        {t("nav.programs")}
      </Link>
      <Link
        to={getLocalizedPath("/contact", currentLang)}
        onClick={onItemClick}
        className="w-full block text-[#020220] text-lg font-semibold leading-10 hover:text-[#037897] transition-colors"
      >
        {t("nav.contact")}
      </Link>
    </div>
  );
};

export default Menu;
